import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getLeadMagnet, VerifyattendesForm } from "../api/utils";
import useFetch from "../api/hooks/useFetch";
import cogoToast from "cogo-toast";
import {
  TextField,
  Checkbox,
  FormControlLabel,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import axios from "axios";
import "../assets/stylesheets/bootstrap.min.css";
import "../assets/stylesheets/style.css";
import "../assets/stylesheets/responsive.css";

export default function AttendesWebinar() {
  // Format date as "12/Jun/2025"
  const formatWebinarDate = (dateString) => {
    if (!dateString) return "Date not specified";

    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const date = new Date(dateString);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();

    return `${day} ${month}, ${year}`;
  };

  // Format duration as "2 hr 30 min"
  const formatDuration = (duration) => {
    if (!duration) return "Duration not specified";

    // Assuming duration is in minutes (e.g., "150" minutes)
    const totalMinutes = parseInt(duration);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    let formatted = "";
    if (hours > 0) formatted += `${hours} hr `;
    if (minutes > 0) formatted += `${minutes} min`;

    return formatted || "0 min";
  };

  const slug =
    "build-a-business-that-runs-without-you-the-secret-is-in-your-resources";
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });
  const [showError, setShowError] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [registrationStatus, setRegistrationStatus] = useState("Pending");
  const [webinarDetails, setWebinarDetails] = useState(null);

  const { token } = useParams(); // Add this near your other hooks

  const [isWebinarExpired, setIsWebinarExpired] = useState(false);

  const {
    apiData: leadMagnet,
    isLoading: isLeadMagnetLoading,
    error: leadMagnetError,
  } = useFetch(getLeadMagnet, slug);

  useEffect(() => {
    if (leadMagnetError) {
      cogoToast.error("Failed to load content");
    } else if (leadMagnet?.status === "error") {
      cogoToast.error("Failed to load content");
    }

    // Check if webinar date is in the past
    if (leadMagnet?.offering_type === "Webinar" && leadMagnet?.webinar_date) {
      const webinarDate = new Date(leadMagnet.webinar_date);
      const today = new Date();
      if (webinarDate < today) {
        setIsWebinarExpired(true);
      }
    }
  }, [leadMagnetError, leadMagnet]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };

  const submitLeadForm = async () => {
    const { name, email, phone } = formData;

    if (!name.trim() || !email.trim() || !phone.trim()) {
      setShowError(true);
      cogoToast.info("Please fill in all required fields");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setShowError(true);
      cogoToast.error("Please enter a valid email address");
      return;
    }

    const phoneRegex = /^\d{10}$/;
    if (!phoneRegex.test(phone)) {
      setShowError(true);
      cogoToast.error("Phone number must be exactly 10 digits");
      return;
    }

    setIsSubmitting(true);

    try {
      const payload = {
        name,
        email,
        phone,
        slug,
        token, // Using the token from useParams
      };

      const response = await VerifyattendesForm(payload, token, slug);

      if (response.status === "success") {
        setWebinarDetails({
          title: response.data.webinar_details.title,
          date: response.data.webinar_details.date,
          duration: response.data.webinar_details.duration,
          join_link: response.data.webinar_details.join_link,
        });
        setRegistrationStatus("success");
        cogoToast.success(response.message);
      } else if (response.status === "error") {
        cogoToast.error(response.message);
      } else if (response.status === "info") {
        cogoToast.info(response.message);
      }
    } catch (err) {
      console.error("Verification error:", err);
      cogoToast.error(
        "Something went wrong during verification. Please try again.",
      );
    } finally {
      setIsSubmitting(false);
    }
  };
  if (isLeadMagnetLoading) {
    return (
      <div
        className="container"
        style={{ justifyContent: "center", display: "flex" }}
      >
        <p>Loading...</p>
      </div>
    );
  }

  if (isWebinarExpired) {
    return (
      <div
        className="container"
        style={{ justifyContent: "center", display: "flex" }}
      >
        <div
          className="top-footer"
          style={{
            paddingVertical: "20 !important",
            width: "75%",
          }}
        >
          <div className="row justify-content-center">
            <div
              className="col-lg-8 text-center "
              style={{ paddingTop: 150, paddingBottom: 150 }}
            >
              <div className="card p-4 p-md-5">
                <h1
                  className="tc-primary head-font mb-4"
                  style={{ fontSize: "2.5rem" }}
                >
                  {leadMagnet?.title}
                </h1>
                <div className="icon-wrapper mb-4">
                  <i
                    className="fas fa-exclamation-circle"
                    style={{ fontSize: "64px", color: "#dc3545" }}
                  ></i>
                </div>

                <p className="mb-4" style={{ color: "#0A2458" }}>
                  Registrations for this workshop is now closed.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (registrationStatus === "success") {
    return (
      <div
        className="container"
        style={{ justifyContent: "center", display: "flex" }}
      >
        <div
          className="top-footer"
          style={{ paddingVertical: "20 !important", width: "75%" }}
        >
          <div className="row justify-content-center">
            <div
              className="col-lg-8 text-center"
              style={{ paddingTop: 150, paddingBottom: 150 }}
            >
              <div className="card p-4 p-md-5">
                <h4 className="tc-primary head-font mb-4">Thank You!</h4>
                <div className="icon-wrapper mb-4">
                  <i
                    className="fas fa-check-circle"
                    style={{ fontSize: "64px", color: "#28a745" }}
                  ></i>
                </div>
                <p className="fs-24 mb-4" style={{ color: "#495057" }}>
                  Your details have been verified!
                </p>

                {webinarDetails && (
                  <div className="webinar-info mt-4 text-left">
                    <h5 className="text-center mb-4">Workshop Details:</h5>

                    <p>
                      {" "}
                      <strong>Title:</strong> {webinarDetails.title}
                    </p>

                    <p>
                      {" "}
                      <strong>Date:</strong>{" "}
                      {formatWebinarDate(webinarDetails.date)}
                    </p>

                    <p>
                      {" "}
                      <strong>Duration:</strong> {webinarDetails.duration}
                    </p>

                    <p>
                      Meeting link:{" "}
                      <a
                        href={webinarDetails.join_link}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {webinarDetails.join_link}
                      </a>
                    </p>
                  </div>
                )}

                <p className="mb-4 mt-4" style={{ color: "#0A2458" }}>
                  If you have any questions, please contact support.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  if (registrationStatus === "failure") {
    return (
      <div
        className="container"
        style={{ justifyContent: "center", display: "flex" }}
      >
        <div
          className="top-footer"
          style={{
            paddingVertical: "20 !important",
            width: "75%",
          }}
        >
          <div className="row justify-content-center">
            <div
              className="col-lg-8 text-center "
              style={{ paddingTop: 150, paddingBottom: 150 }}
            >
              <div className="card p-4 p-md-5">
                <h4 className="tc-primary head-font mb-4">
                  Registration for workshop: {leadMagnet?.title} failed!
                </h4>
                <div className="icon-wrapper mb-4">
                  <i
                    className="fas fa-exclamation-circle"
                    style={{ fontSize: "64px", color: "#dc3545" }}
                  ></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <main className="wrapper">
        <section className="page-hero-sec">
          <div className="container">
            <div className="row justify-content-center">
              <div className="row justify-content-center">
                <div className="col-lg-6 pb-5">
                  <h1 className="tc-primary head-font text-center pb-1">
                    Workshop Attendance
                  </h1>
                  <h4 className="tc-primary head-font text-center pb-5">
                    {leadMagnet?.title}
                  </h4>
                  {/* <p className="tc-primary fs-24" style={{ textAlign: "justify" }}>
                    {leadMagnet?.subtitle}
                  </p> */}

                  <div className="webinar-details mt-4">
                    <p>
                      <strong>Date:</strong>{" "}
                      {formatWebinarDate(leadMagnet?.webinar_date)}
                    </p>
                    <p>
                      <strong>Duration:</strong> {leadMagnet?.duration}
                    </p>
                  </div>
                </div>
              </div>

              <div className="col-lg-6 col-md-8">
                <div className="row">
                  <div className="col-lg-12">
                    <TextField
                      fullWidth
                      label="Full Name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      error={showError && !formData.name.trim()}
                      helperText={
                        showError && !formData.name.trim()
                          ? "Name is required"
                          : ""
                      }
                      required
                      margin="dense"
                      sx={{
                        "& input": {
                          background: "#e0e5ef",
                        },
                      }}
                      inputProps={{ maxLength: 200 }}
                    />
                  </div>

                  <div className="col-lg-12 mt-3">
                    <TextField
                      fullWidth
                      label="Email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      error={
                        showError &&
                        (!formData.email.trim() ||
                          !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
                      }
                      helperText={
                        showError && !formData.email.trim()
                          ? "Email is required"
                          : showError &&
                              !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
                            ? "Invalid email format"
                            : ""
                      }
                      required
                      margin="dense"
                      sx={{
                        "& input": {
                          background: "#e0e5ef",
                        },
                      }}
                      inputProps={{ maxLength: 200 }}
                    />
                  </div>

                  <div className="col-lg-12 mt-3">
                    <TextField
                      fullWidth
                      label="Phone Number"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      error={
                        showError &&
                        (!formData.phone.trim() ||
                          !/^\d{10}$/.test(formData.phone))
                      }
                      helperText={
                        showError && !formData.phone.trim()
                          ? "Phone is required"
                          : showError && !/^\d{10}$/.test(formData.phone)
                            ? "Must be 10 digits"
                            : ""
                      }
                      required
                      margin="dense"
                      sx={{
                        "& input": {
                          background: "#e0e5ef",
                        },
                      }}
                      inputProps={{ maxLength: 10 }}
                    />
                  </div>

                  <div className="col-lg-12 mt-4">
                    <button
                      onClick={submitLeadForm}
                      disabled={isSubmitting}
                      className="link_btn mt-4 mx-auto"
                      style={{ marginBottom: 50 }}
                    >
                      {isSubmitting ? "Verifying..." : "Verify Attendance"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
